import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import env from './env';

// Initialize Sentry
const initSentry = () => {
    // Only initialize in production or if DSN is provided
    if (env.SENTRY_DSN) {
        Sentry.init({
            dsn: env.SENTRY_DSN,
            environment: env.NODE_ENV,
            integrations: [
                new BrowserTracing({
                    // Set tracing origins to include your backend
                    tracingOrigins: ['localhost', /^\//],
                }),
            ],
            // Performance Monitoring
            tracesSampleRate: env.IS_PRODUCTION ? 0.1 : 1.0, // 10% in production, 100% in dev
            // Session Replay (optional - can be enabled for better debugging)
            replaysSessionSampleRate: env.IS_PRODUCTION ? 0.1 : 1.0,
            replaysOnErrorSampleRate: 1.0, // Always record sessions with errors
            // Release tracking
            release: env.VERSION + (env.GIT_SHA ? `-${env.GIT_SHA.substring(0, 7)}` : ''),
            // Filter out sensitive data
            beforeSend(event, _hint) {
                // Don't send events in development unless explicitly enabled
                if (env.IS_DEVELOPMENT && !env.SENTRY_ENABLE_DEV) {
                    return null;
                }

                // Filter sensitive information from URLs
                if (event.request?.url) {
                    event.request.url = event.request.url.replace(/token=[^&]*/gi, 'token=[REDACTED]');
                    event.request.url = event.request.url.replace(/password=[^&]*/gi, 'password=[REDACTED]');
                }

                // Filter sensitive data from user context
                if (event.user) {
                    delete event.user.ip_address;
                }

                return event;
            },
            // Ignore certain errors
            ignoreErrors: [
                // Browser extensions
                'top.GLOBALS',
                'originalCreateNotification',
                'canvas.contentDocument',
                'MyApp_RemoveAllHighlights',
                'atomicFindClose',
                // Network errors that are not actionable
                'NetworkError',
                'Network request failed',
                'Failed to fetch',
                // Chrome extensions
                'chrome-extension://',
                'moz-extension://',
            ],
        });
    }
};

export default initSentry;

